import { Avatar, SxProps } from '@b2b-ui';
import React from 'react';

function stringToColor(string: string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

function stringAvatar(name: string, sx: SxProps = {}) {
    const chunks = name.trim().toUpperCase().split(' ');
    const cleanedName = chunks.length > 1 ? `${chunks[0][0]}${chunks[1][0]}` : chunks[0][0];
    return {
        sx: {
            ...sx,
            bgcolor: stringToColor(name),
        },
        children: `${cleanedName || ''}`,
    };
}

interface StringAvatarProps {
    fullName: string;
    sx?: SxProps;
}

export const StringAvatar = ({ fullName, sx }: StringAvatarProps) => {
    return <Avatar {...stringAvatar(fullName, sx)} />;
};
